import * as API from './'

export default {
    //报纸名称列表
    namelist: params => {
        return API.POST('api/news/getType', params)
    },
    //报纸卷号列表
    volumename: params => {
        return API.POST('api/news/getVolumeName', params)
    },
    //名称列表
    homelist: params => {
        return API.POST('api/news/list', params)
    },
    //详情
    details: params => {
        return API.POST('api/news/details', params)
    },
    //搜索
    search: params => {
        return API.POST('api/news/search', params)
    }
}